"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _session, _notification, _conference, _mediaDevice, _recording, _filePresentation, _videoPresentation, _broadcasting, _command, _videoFilters, _extensions, _telemetry, _browserEvent;
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const services_1 = require("./services");
const logging_1 = __importDefault(require("./lib/logging"));
const VoxeetApi_1 = __importDefault(require("./api/VoxeetApi"));
const TelemetryApi_1 = __importDefault(require("./api/TelemetryApi"));
/**
 * VoxeetSDK is the main object that allows the application to interact with Voxeet services. The SDK is asynchronous and uses promise at its core.
 *
 * @noInheritDoc
 */
class VoxeetSDK extends events_1.EventEmitter {
    /**
     * @deprecated Will became private
     */
    constructor() {
        super();
        /**
         * The Session Service
         */
        _session.set(this, new services_1.SessionService(this));
        /**
         * The Notification Service.
         * @ignore
         */
        _notification.set(this, new services_1.NotificationService(this, __classPrivateFieldGet(this, _session)));
        /**
         * The Conference Service
         */
        _conference.set(this, new services_1.ConferenceService(this, __classPrivateFieldGet(this, _session)));
        /**
         * The Media Device Service
         */
        _mediaDevice.set(this, new services_1.MediaDeviceService(this, __classPrivateFieldGet(this, _conference)));
        /**
         * The Conference Recording Service
         */
        _recording.set(this, new services_1.RecordingService(this));
        /**
         * The File Presentation Service
         */
        _filePresentation.set(this, new services_1.FilePresentationService(this, __classPrivateFieldGet(this, _conference)));
        /**
         * The Video Presentation Service
         */
        _videoPresentation.set(this, new services_1.VideoPresentationService(this, __classPrivateFieldGet(this, _conference)));
        /**
         * The Live Streaming Service
         */
        _broadcasting.set(this, new services_1.BroadcastingService(this));
        /**
         * The Command Message Service
         */
        _command.set(this, new services_1.CommandService(this, __classPrivateFieldGet(this, _conference)));
        /**
         * The VirtualFilters service
         */
        _videoFilters.set(this, new services_1.VideoFiltersService(this, __classPrivateFieldGet(this, _conference), __classPrivateFieldGet(this, _session)));
        /**
         * The Extensions service
         * @ignore
         */
        _extensions.set(this, new services_1.ExtensionsService(this));
        /**
         * The Telemetry service
         * @ignore
         */
        _telemetry.set(this, __FLAVOR__ !== 'devssl' && new services_1.TelemetryService(this, __classPrivateFieldGet(this, _conference), __classPrivateFieldGet(this, _session)));
        /**
         * The BrowserEvent service
         * @ignore
         */
        _browserEvent.set(this, new services_1.BrowserEventService(this, __classPrivateFieldGet(this, _conference)));
    }
    /**
     * Retrieves the [SessionService](doc:js-client-sdk-sessionservice) instance that allows the participant to use sessions.
     */
    static get session() {
        return __classPrivateFieldGet(this.instance, _session);
    }
    /**
     * Retrieves the [MediaDeviceService](doc:js-client-sdk-mediadeviceservice) instance that allows the participant to interact with devices through the system.
     */
    static get mediaDevice() {
        return __classPrivateFieldGet(this.instance, _mediaDevice);
    }
    /**
     * Retrieves the [ConferenceService](doc:js-client-sdk-conferenceservice) instance that allows the participant to interact with conferences.
     */
    static get conference() {
        return __classPrivateFieldGet(this.instance, _conference);
    }
    /**
     * Retrieves the [RecordingService](doc:js-client-sdk-recordingservice) instance that allows the participant to record conferences.
     */
    static get recording() {
        return __classPrivateFieldGet(this.instance, _recording);
    }
    /**
     * Retrieves the [FilePresentationService](doc:js-client-sdk-filepresentationservice) instance that allows the participant to use file presentations.
     */
    static get filePresentation() {
        return __classPrivateFieldGet(this.instance, _filePresentation);
    }
    /**
     * Retrieves the [VideoPresentationService](doc:js-client-sdk-videopresentationservice) instance that allows the participant to use video presentations.
     */
    static get videoPresentation() {
        return __classPrivateFieldGet(this.instance, _videoPresentation);
    }
    /**
     * The Video Stream Broadcasting Service.
     * @ignore
     */
    static get broadcasting() {
        return __classPrivateFieldGet(this.instance, _broadcasting);
    }
    /**
     * Retrieves the [CommandService](doc:js-client-sdk-commandservice) instance that allows the participant to send messages to the specified conferences.
     */
    static get command() {
        return __classPrivateFieldGet(this.instance, _command);
    }
    /**
     * Retrieves the [VideoFiltersService](doc:js-client-sdk-videofiltersservice) instance that allows the local participant to blur the participant's background or use a selected image as the background.
     */
    static get videoFilters() {
        return __classPrivateFieldGet(this.instance, _videoFilters);
    }
    /**
     * Retrieves the [NotificationService](doc:js-client-sdk-notificationservice) instance that allows forwarding notifications from developers to the properly registered managers.
     *
     *
     */
    static get notification() {
        return __classPrivateFieldGet(this.instance, _notification);
    }
    /**
     * @ignore
     */
    static get extensions() {
        return __classPrivateFieldGet(this.instance, _extensions);
    }
    /**
     * Initializes the SDK using the customer key and secret.
     *
     * @param customerKey - The customer key.
     * @param customerSecret - The customer secret.
     * @param __namedParameters Optional parameter to override SDK default configuration
     * @param host host
     * @param wsHost wshost
     * @param enableTelemetry enable telemetry
     * @param telemetryHost telemetry host
     */
    static initialize(customerKey, customerSecret, { host = this.host, wsHost = this.wsHost, enableTelemetry = this.enableTelemetry, telemetryHost = this.telemetryHost } = {}) {
        VoxeetSDK.session.customerKey = customerKey;
        VoxeetSDK.session.customerSecret = customerSecret;
        VoxeetApi_1.default.wsHost = VoxeetSDK.flavor === 'devssl' ? wsHost : this.wsHost;
        VoxeetApi_1.default.host = VoxeetSDK.flavor === 'devssl' ? host : this.host;
        TelemetryApi_1.default.host = VoxeetSDK.flavor === 'devssl' ? telemetryHost : this.telemetryHost;
        VoxeetSDK.enableTelemetry = VoxeetSDK.flavor === 'devssl' ? enableTelemetry : this.enableTelemetry;
        VoxeetSDK.displaySettings();
    }
    /**
     * display SDK settings to the browser console.
     * @ignore
     */
    static displaySettings() {
        console.group('SDK settings:');
        console.log('VoxeetSDK version: ' + VoxeetSDK.version);
        console.log('VoxeetSDK flavor: ' + VoxeetSDK.flavor);
        console.log(`Telemetry status: ${VoxeetSDK.enableTelemetry ? 'enabled' : 'disabled'}`);
        if (VoxeetSDK.flavor === 'devssl') {
            console.group('hosts');
            console.log(`Gate endpoint: ${VoxeetApi_1.default.host}`);
            console.log(`WebSocket endpoint: ${VoxeetApi_1.default.wsHost}`);
            VoxeetSDK.enableTelemetry && console.log(`Telemetry endpoint: ${TelemetryApi_1.default.host}`);
            console.groupEnd();
        }
        console.groupEnd();
    }
    /**
     * Initialize the SDK with an access token that is provided by the customer backend communicating with Voxeet servers. The token allows securing the customer key and secret.
     *
     * The following diagram presents the authentication flow:
     *
     * ```
     * Client          Customer Server       Voxeet Server
     *   |                    |                    |
     *   |  Get Access Token  |  /oauth2/token (1) |
     *   |------------------->|------------------->|
     *   |    Access Token    |    Access Token    |
     *   |<-------------------|<-------------------|
     *   |  initializeToken(accessToken, callback) |
     *   |---------------------------------------->|
     * ```
     *
     * The access token has a limited period of validity and needs to be refreshed for security reasons. In such case,
     * The Voxeet SDK will call the callback provided to initializeToken. The callback must return a Promise
     * containing the refreshed access token by calling the customer backend, as presented in the following diagram:
     *
     * ```
     * Client          Customer Server       Voxeet Server
     *   |      callback      |  /oauth2/token (2) |
     *   |------------------->|------------------->|
     *   |    Access Token    |    Access Token    |
     *   |<-------------------|<-------------------|
     * ```
     *
     * Where (1) and (2) are two REST API endpoints available on Voxeet servers and documented on the developer portal.
     *
     * @param accessToken - The access token provided by the customer's backend
     * @param callback - A callback returning a promise, called when the access token needs to refreshed
     * @param __namedParameters Optional parameter to override SDK default configuration
     * @param host host
     * @param wsHost wshost
     * @param enableTelemetry enable telemetry
     * @param telemetryHost telemetry host
     */
    static initializeToken(accessToken, callback, { host = this.host, wsHost = this.wsHost, enableTelemetry = this.enableTelemetry, telemetryHost = this.telemetryHost } = {}) {
        VoxeetApi_1.default.accessToken = accessToken;
        VoxeetApi_1.default.tokenCallback = callback;
        VoxeetApi_1.default.wsHost = VoxeetSDK.flavor === 'devssl' ? wsHost : this.wsHost;
        VoxeetApi_1.default.host = VoxeetSDK.flavor === 'devssl' ? host : this.host;
        VoxeetSDK.enableTelemetry = VoxeetSDK.flavor === 'devssl' ? enableTelemetry : this.enableTelemetry;
        TelemetryApi_1.default.host = VoxeetSDK.flavor === 'devssl' ? telemetryHost : this.telemetryHost;
        VoxeetApi_1.default.leavingCallback = () => {
            __classPrivateFieldGet(this.instance, _conference).leave();
        };
        VoxeetSDK.displaySettings();
    }
    /**
     * Allows to request for a specific region. This method must be called after initialize and before opening a session.
     * @param region
     * @ignore
     */
    static region(region = '') {
        VoxeetApi_1.default.setRegion(region);
    }
}
exports.default = VoxeetSDK;
_session = new WeakMap(), _notification = new WeakMap(), _conference = new WeakMap(), _mediaDevice = new WeakMap(), _recording = new WeakMap(), _filePresentation = new WeakMap(), _videoPresentation = new WeakMap(), _broadcasting = new WeakMap(), _command = new WeakMap(), _videoFilters = new WeakMap(), _extensions = new WeakMap(), _telemetry = new WeakMap(), _browserEvent = new WeakMap();
VoxeetSDK.instance = new VoxeetSDK();
/**
 * @ignore
 * The current SDK version.
 */
VoxeetSDK.version = __VERSION__;
VoxeetSDK.host = __HOST__;
VoxeetSDK.wsHost = __WS_HOST__;
VoxeetSDK.telemetryHost = __TELEMETRY_HOST__;
VoxeetSDK.enableTelemetry = __ENABLE_TELEMETRY__;
/**
 * @ignore
 * the current sdk flavor
 */
VoxeetSDK.flavor = __FLAVOR__;
logging_1.default.setLevel('error');
